import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActiveSubscription } from '../../subscription/models/active-subscription';
import { SubscriptionTier } from '../../subscription/enums/subscription-tier.enum';

@Component({
  selector: 'app-top-banner',
  templateUrl: './top-banner.component.html',
  styleUrl: './top-banner.component.scss'
})
export class TopBannerComponent implements OnChanges{

  @Input() message:string = '';
  @Input() activeSubscription: ActiveSubscription | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if(!changes['activeSubscription']?.currentValue){
      this.message = "You don't have any active subscription, Subscribe to enjoy our service ✨"
    }else{
      this.message = this.getMessage(this.activeSubscription!);
    }
  }

  private getMessage(activeSubscription: ActiveSubscription){
    if(!activeSubscription){
      return "You don't have any active subscription, Subscribe to enjoy our service ✨";
    }

    const remainingDays = this.getDaysRemaining(activeSubscription.endDate);
    if(remainingDays < 3 && remainingDays > 0){
      return "⏰ Your plan will expire soon, Renew your subscription to get uninterrupted access!"
    }

    if(activeSubscription.creditsLeft < 1000 && activeSubscription.tier !== 'ENTERPRISE'){
      return "You are having less than 1000 credits 🪫, Top-up more to get un interrupted access 🚀";
    }

    if(activeSubscription.tier === SubscriptionTier.FREE){
      return "You are in Free tier, Upgrade your tier to reconcile huge data 📈"
    }
    return ""
  }

  getDaysRemaining(expiryDate: Date) {
    const today = new Date();
    const expiry = new Date(expiryDate);

    // Calculate the difference in days
    const timeDiff = expiry.getTime() - today.getTime();
    const remainingDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert ms to days
    return remainingDays;
  }
}
